export enum UploadDocumentTypes {
  ORDER = 'Order',
  COMPLAINT = 'Complaint'
}
